import { CustomDimensionsOrParams } from '../google-analytics/ga4Types';
import { createFirebaseAdapter } from '../firebase/firebaseAdapter';
import { createFirebaseClient } from '../firebase/firebaseClient';
import {
  getEcommerceData,
  getFlowAndProductFromCurrentPageName,
  isGa4EcommerceData,
} from './utils';
import { getUserPropertiesFromDimensions } from '../google-analytics/ga4';
import { gtagWrapper } from '../google-analytics/common';
import { ECommerce4Transaction, TrackECommerceArg } from './types';
import { handleECommerceTransactionDataError } from './error';
import { trackUserProperties } from '../../configParametersRepository/storageClient/utils';
import { trackPage } from '../thirdPartyTrackingAgent/pages';

const trackECommerceGa4 = (eCommerceData: ECommerce4Transaction): void => {
  gtagWrapper('event', 'purchase', eCommerceData);
};

const trackWebECommerce = (ga4Data: ECommerce4Transaction) => {
  trackECommerceGa4(ga4Data);
};

const trackNativeECommerce = (ga4Data: ECommerce4Transaction) => {
  const firebaseAdapter = createFirebaseAdapter();
  const firebaseClient = createFirebaseClient(firebaseAdapter);
  firebaseClient.trackECommerce(ga4Data);
};

export const trackECommerceData = (
  eCommerceData: TrackECommerceArg | ECommerce4Transaction
) => {
  const { ga4Data } = getEcommerceData(eCommerceData);
  handleECommerceTransactionDataError(ga4Data);
  trackWebECommerce(ga4Data);
  trackNativeECommerce(ga4Data);
};

export const trackConfirmation = async () => {
  const flowAndProduct = getFlowAndProductFromCurrentPageName();
  if (!flowAndProduct) return;
  const confirmationVirtualPage = `${flowAndProduct}/confirmation/`;
  await trackPage(confirmationVirtualPage, { funnel: true });
};

export const trackECommerceUserProperties = (
  eCommerceData: TrackECommerceArg | ECommerce4Transaction
) => {
  const products = isGa4EcommerceData(eCommerceData)
    ? eCommerceData.items
    : eCommerceData.products;
  products.forEach((item) => {
    const eCommerceUserProperties = getUserPropertiesFromDimensions(
      item as CustomDimensionsOrParams
    );
    trackUserProperties(eCommerceUserProperties);
  });
};
